/* Category navigation only; filtering, sorting and cart remain native theme behavior. */
(() => {
  if (window.bademaCollectionJumpBound) return;
  window.bademaCollectionJumpBound = true;
  document.addEventListener('change', event => {
    const select = event.target.closest?.('select[data-bd-collection-jump]');
    if (!select || !select.value) return;
    const url = new URL(select.value, window.location.origin);
    if (url.origin === window.location.origin && url.pathname.includes('/collections/')) window.location.assign(url.href);
  });
})();
